/* eslint-disable camelcase */
import { Option, OptionData } from './Option';
import { Dictionary } from './Dictionary';

export enum District {
  state = 'state',
  house = 'house',
}

export interface StateRegionOption extends Option<number> {
  stateId: number;
}

export interface LocationState {
  id: number;
  stateCode: string;
  stateName: string;
}

export type LocationOption = OptionData<LocationState, number>;

export interface DistrictCodeDTO {
  district_id: string;
  district_name: string;
  geo_code: number;
  id: number;
}

export interface DistrictCode {
  districtId: string;
  districtName: string;
  geoCode: number;
  id: number;
}

export interface DistrictOption extends Option<number> {
  abbreviation?: string;
  id?: number | string;
  stateId?: number;
  parentId?: number;
  geojsonUrl?: string;
}

export interface CityOption extends Option<number> {
  stateId: number;
}

export const convertDistrictCodeToDTO = (value: DistrictCode): DistrictCodeDTO => {
  return {
    district_id: value.districtId,
    district_name: value.districtName,
    geo_code: value.geoCode,
    id: value.id,
  };
};

export const convertDistrictCodeFromDTO = (value: DistrictCodeDTO): Dictionary => {
  return {
    id: value.id,
    name: `${value.geo_code} - ${value.district_name}`,
  };
};

export interface LocationStateDTO {
  id: number;
  state_code: string;
  state_name: string;
}

export const convertLocationStateToDTO = (value: LocationState): LocationStateDTO => {
  return {
    state_code: value.stateCode,
    state_name: value.stateName,
    id: value.id,
  };
};

export const convertLocationStateFromDTO = (value: LocationStateDTO): LocationState => {
  return {
    id: value.id,
    stateName: value.state_name,
    stateCode: value.state_code,
  };
};

export type LocationButtonOption = Option<string> & {
  onlyUSA?: boolean;
  isArea?: boolean;
  allStates?: boolean;
};

export interface ICountryOption extends Option<number> {
  shortName?: string;
}

export interface IStateOption extends Option<number> {
  abbreviation?: string;
  stateCode?: string;
  parentId?: number;
  geojsonUrl?: string;
}

export interface ILocationGeoRadiusFileData {
  address: string;
  latitude: number;
  locationId: number;
  longitude: number;
  radius: number;
  countryShortName?: string;
  stateShortName?: string;
}

export interface ILocaitionGeoRadiusFile {
  fileId: number;
  invalidLocationsCount: number;
  validLocations: ILocationGeoRadiusFileData[];
}

export type TLocationFileType = 'locations' | 'addresses' | 'polygons';

export type RadiusUpdatedLocations = {
  [key: string]: number;
} | null;

export interface ILocationFilter {
  id: number;
  order: number;
  name: string;
}

export interface ILocations {
  id: number;
  name: string;
  abbreviation?: string;
  parentId: number;
  geojsonUrl: string;
}

export interface ILocationTypeWithOptions {
  [key: string]: ILocations[];
}

export interface IZipCodeInfo {
  id: number;
  name: string;
  parentId: number;
  geojsonUrl: string;
}
